"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./styles"));

var _FlexGrow = _interopRequireDefault(require("../components/FlexGrow1"));

var _ContentImage = _interopRequireDefault(require("../components/ContentImage"));

var _Description = _interopRequireDefault(require("../components/Description"));

var _DurationInfo = _interopRequireDefault(require("../components/DurationInfo"));

var _DarkText = _interopRequireDefault(require("../../DarkText"));

var _FormattedDate = _interopRequireDefault(require("../components/FormattedDate"));

function ContentCardMedium(props) {
  var theme = props.theme,
      name = props.name,
      contentId = props.contentId,
      className = props.className,
      date = props.date;
  return _react.default.createElement("div", {
    key: contentId,
    className: (0, _classnames.default)(s.root(theme), className)
  }, _react.default.createElement(_ContentImage.default, (0, _extends2.default)({}, props, {
    height: 120,
    width: 180,
    badgeIconSize: 44,
    className: s.contentImage
  })), _react.default.createElement("div", {
    className: s.contentInfo
  }, _react.default.createElement(_DarkText.default, {
    fontSize: 20,
    bold: true,
    color: "copper",
    className: s.name
  }, name), _react.default.createElement(_Description.default, props), _react.default.createElement(_FlexGrow.default, null), _react.default.createElement("div", {
    className: s.bottomInfo
  }, _react.default.createElement(_FormattedDate.default, {
    date: date
  }), _react.default.createElement(_DurationInfo.default, (0, _extends2.default)({
    key: "DurationInfo"
  }, props)), _react.default.createElement(_FlexGrow.default, null))));
}

var _default = (0, _emotionTheming.withTheme)(ContentCardMedium);

exports.default = _default;